// @ts-check

import { generateMock } from '@anatine/zod-mock';
import { faker } from '@faker-js/faker';

import { Envelope } from '@/store/modules/envelopes/models/Envelope';

/** @typedef {import('@/store/modules/envelopes/models/Envelope').TEnvelope} TEnvelope */

/**
 * @param {Partial<TEnvelope>} [properties]
 *
 * @returns {TEnvelope}
 */
// eslint-disable-next-line import/prefer-default-export
export function createEnvelope(properties = {}) {
  const envelope = generateMock(Envelope, {
    stringMap: {
      fingerprint: () => faker.string.uuid(),
    },
  });

  /** @type {Partial<TEnvelope>} */
  const defaults = {
    auto_remind_hours: faker.number.int(14) * 24,
    next_expire: faker.date.soon().getTime() / 1000,
    sent_at: null,
  };

  return { ...envelope, ...defaults, ...properties };
}
